const street = (index, name, group, price, rents, buildCost) => ({
  index,
  name,
  type: 'street',
  group,
  price,
  rents,
  buildCost,
  mortgageValue: Math.floor(price / 2),
});

const transport = (index, name) => ({
  index,
  name,
  type: 'transport',
  group: 'transport',
  price: 200,
  rents: [25, 50, 100, 200],
  buildCost: null,
  mortgageValue: 100,
});

const utility = (index, name) => ({
  index,
  name,
  type: 'utility',
  group: 'utility',
  price: 150,
  rents: [4, 10],
  buildCost: null,
  mortgageValue: 75,
});

export const BOARD = Object.freeze([
  { index: 0, name: 'Старт', type: 'start', salary: 200 },
  street(1, 'Сосновый бор', 'umber', 60, [2, 10, 30, 90, 160, 250], 50),
  { index: 2, name: 'Городская казна', type: 'community' },
  street(3, 'Лесная долина', 'umber', 60, [4, 20, 60, 180, 320, 450], 50),
  { index: 4, name: 'Городской сбор', type: 'tax', amount: 200 },
  transport(5, 'Северный вокзал'),
  street(6, 'Янтарный берег', 'sky', 100, [6, 30, 90, 270, 400, 550], 50),
  { index: 7, name: 'Шанс', type: 'chance' },
  street(8, 'Приозёрск', 'sky', 100, [6, 30, 90, 270, 400, 550], 50),
  street(9, 'Солнечные холмы', 'sky', 120, [8, 40, 100, 300, 450, 600], 50),
  { index: 10, name: 'Городская тюрьма', type: 'jail' },
  street(11, 'Кленовый парк', 'violet', 140, [10, 50, 150, 450, 625, 750], 100),
  utility(12, 'ЭнергоСервис'),
  street(13, 'Белые скалы', 'violet', 140, [10, 50, 150, 450, 625, 750], 100),
  street(14, 'Высокие технологии', 'violet', 160, [12, 60, 180, 500, 700, 900], 100),
  transport(15, 'Восточный экспресс'),
  street(16, 'Инновации', 'orange', 180, [14, 70, 200, 550, 750, 950], 100),
  { index: 17, name: 'Городская казна', type: 'community' },
  street(18, 'Смарт-Сити', 'orange', 180, [14, 70, 200, 550, 750, 950], 100),
  street(19, 'Креативный кластер', 'orange', 200, [16, 80, 220, 600, 800, 1000], 100),
  { index: 20, name: 'Парк отдыха', type: 'parking' },
  street(21, 'Торговая гавань', 'coral', 220, [18, 90, 250, 700, 875, 1050], 150),
  { index: 22, name: 'Шанс', type: 'chance' },
  street(23, 'Жемчужный пляж', 'coral', 220, [18, 90, 250, 700, 875, 1050], 150),
  street(24, 'Тёплый залив', 'coral', 240, [20, 100, 300, 750, 925, 1100], 150),
  transport(25, 'Речной терминал'),
  street(26, 'Липовая аллея', 'sun', 260, [22, 110, 330, 800, 975, 1150], 150),
  street(27, 'Речной посад', 'sun', 260, [22, 110, 330, 800, 975, 1150], 150),
  utility(28, 'Водоканал'),
  street(29, 'Малиновые поля', 'sun', 280, [24, 120, 360, 850, 1025, 1200], 150),
  { index: 30, name: 'В городскую тюрьму', type: 'goToJail' },
  street(31, 'Солнечный пляж', 'green', 300, [26, 130, 390, 900, 1100, 1275], 200),
  street(32, 'Столичный аэропорт', 'green', 300, [26, 130, 390, 900, 1100, 1275], 200),
  { index: 33, name: 'Городская казна', type: 'community' },
  street(34, 'Тихая гавань', 'green', 320, [28, 150, 450, 1000, 1200, 1400], 200),
  transport(35, 'Западный вокзал'),
  { index: 36, name: 'Шанс', type: 'chance' },
  street(37, 'Кристальная роща', 'navy', 350, [35, 175, 500, 1100, 1300, 1500], 200),
  { index: 38, name: 'Экологический сбор', type: 'tax', amount: 100 },
  street(39, 'Северные ворота', 'navy', 400, [50, 200, 600, 1400, 1700, 2000], 200),
]);

export const GROUPS = Object.freeze(
  BOARD.filter((cell) => cell.type === 'street').reduce((groups, cell) => {
    groups[cell.group] ??= [];
    groups[cell.group].push(cell.index);
    return groups;
  }, {}),
);

export const PROPERTY_TYPES = new Set(['street', 'transport', 'utility']);

export const TOKENS = Object.freeze(['rocket', 'boat', 'bicycle', 'cat', 'globe', 'tree']);

export const PLAYER_COLORS = Object.freeze([
  '#e45f50',
  '#167f78',
  '#d89a28',
  '#7152a6',
  '#2f6db3',
  '#527d3c',
]);

export function cloneBoard() {
  return BOARD.map((cell) => ({
    ...cell,
    rents: cell.rents ? [...cell.rents] : undefined,
  }));
}
